import { ILegalRequirementFullObject } from '../../Interfaces/ILegalRequirement';
import { ILegalTransaction } from '../../Interfaces/ILegalTransaction';
import { IUser } from '../../Interfaces/IUser';

function stringToColor(string: string) {
  let hash = 0;
  let i;

  /* eslint-disable no-bitwise */
  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = '#';

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.slice(-2);
  }
  /* eslint-enable no-bitwise */

  return color;
}

export function stringAvatar(name: string, ColorHex?: string) {
  return {
    sx: {
      bgcolor: ColorHex || stringToColor(name),
      width: 40,
      height: 40,
    },
    children:
      name.length === 0
        ? ''
        : name.split(' ').length === 1
          ? name[0]
          : `${name.split(' ')[0][0]}${name.split(' ')[1][0]}`,
  };
}

const getAvatarSizeByInitials = (len: number) => {
  if (len <= 2) {
    return { size: 40, fontSize: 16 };
  }
  if (len === 3) {
    return { size: 40, fontSize: 15 };
  }
  if (len === 4) {
    return { size: 42, fontSize: 12 };
  }
  return { size: 44, fontSize: 11 };
};

export const getUserAvatarProps = (user: IUser) => {
  const initials = (user.Initials ?? '').trim();

  if (initials.length > 0) {
    const { size, fontSize } = getAvatarSizeByInitials(initials.length);
    return {
      sx: {
        bgcolor: user.ColorHex,
        width: size,
        height: size,
        fontSize: fontSize,
      },
      children: initials,
    };
  }
  return stringAvatar(`${user.FirstName} ${user.LastName}`, user.ColorHex);
};

export const spanTsx = (
  bodyState: string,
  borderProgress: string,
  txt: string | null = null,
  size: number = 25
) => {
  return (
    <>
      <span
        style={{
          padding: txt === null ? undefined : 5,
          backgroundColor: bodyState,
          borderStyle: 'solid',
          borderWidth: 5,
          borderColor: borderProgress,
          borderRadius: txt === null ? '50%' : 25,
          width: txt === null ? size : undefined,
          height: txt === null ? size : undefined,
          display: txt === null ? 'inline-block' : undefined,
        }}
      >
        {txt === null ? undefined : txt}
      </span>
    </>
  );
};

export const instantViewLegalTransaction = (
  testLegalTransaction: ILegalTransaction | ILegalRequirementFullObject,
  offerwriteTitle: string | null = null
) => {
  let borderProgress = '#808080';
  let bodyState = '#c8c8c8 ';

  if (testLegalTransaction.idLegalTransactionState === 5) {
    bodyState = '#f2f299';
  } else if (testLegalTransaction.idLegalTransactionState === 10) {
    bodyState = '#c9d8f8';
  } else if (testLegalTransaction.idLegalTransactionState === 50) {
    bodyState = '#f5cfb4';
  } else if (testLegalTransaction.idLegalTransactionState === 100) {
    bodyState = '#99CC99';
  }

  if (testLegalTransaction.idLegalTransactionProgress === 20) {
    borderProgress = '#0f1b73';
  } else if (testLegalTransaction.idLegalTransactionProgress === 30) {
    borderProgress = '#FF2C2C';
  } else if (testLegalTransaction.idLegalTransactionProgress === 40) {
    borderProgress = '#008000';
  }

  return spanTsx(
    bodyState,
    borderProgress,
    offerwriteTitle === null ? testLegalTransaction.Title : offerwriteTitle
  );
};
